import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDecodedParams } from "../misc/utils";

const ResultPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id } = useDecodedParams();

  return (
    <div className="page-view event-detail">
      <img className="logo mt-2 mb-6" src="/EP_logo_withwords-01.png" alt="pause-and-breathe-logo" />
      <form
        key="userInfoForm"
        id="userInfoForm"
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      >
        <div className={`card-view donation-card donation-result-card`} style={{ marginBottom: "40px" }}>
          {id === "2430e09" ? (
            <>
              <h1 className="mb-1">{t("Event Success Result")}</h1>
              <h4>
                {t("success Pay at Site")}
                {/* <a href="cs@elite-paradise.tech">cs@elite-paradise.tech</a> connection. */}
              </h4>
            </>
          ) : id === "failed" ? (
            <>
              <h1 className="mb-1">{t("Something wrong")}</h1>
              <h4>
              {t("fail Pay at Site")}
              </h4>
            </>
          ) : id === "fail" ? (
            <>
              <h1 className="mb-1">{t("Event Transaction Fail Result")}</h1>
              <h4>
                抱歉，系統出錯並已關閉，系統將不會保留該名額，請重新登記。如果對是項操作有任何問題，請與
                <a href="cs@elite-paradise.tech">cs@elite-paradise.tech</a> 聯絡。
              </h4>
            </>
          ) : id === "2430e0" ? (
            <>
              <h1 className="mb-1">{t("Event Success Result")}</h1>
              <h4>
                {t("success enroll")}
                
              </h4>
            </>
          ):null}
        </div>
        <div className={`my-5 btns-gp-div`}>
          <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              navigate(`/${JSON.parse(window.sessionStorage.getItem("event"))?.event_id}`);
            }}
          >
            {t("Back")}
          </Button>
        </div>
      </form>
      {/* <div>{`event ${id || "none"}`}</div> */}
    </div>
  );
};

export default ResultPage;
